/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import hashTagChecker from '@shared/utils/HashTagChecker';
// Component
import SearchSuggestion from '@features/SearchSuggestion';

// styles
import './NavbarSearch.css';

function NavbarSearch() {
  // useState hooks
  const [input, setInput] = useState(''); // input value
  const [suggestion, setSuggestion] = useState([]); // search suggestion
  const [activeSuggestion, setActiveSuggestion] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const history = useHistory();

  const ref = useRef();

  let sourceUrl;
  if (typeof window !== 'undefined') {
    sourceUrl = window.location.pathname;
  }

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isMenuOpen]);

  const checkSourceUrl = () => {
    switch (sourceUrl) {
    case '/':
      return 'Homepage';
    case '/live':
      return 'Browse';
    case '/klips':
      return 'Browse';
    case '/search/index':
      return 'Search';
    case '/coins':
      return 'Buy Coins';
    case '/coins/payment':
      return 'Buy Coins';
    case '/coins/payment/status':
      return 'Buy Coins';
    case '/wallet':
      return 'Wallet';
    case '/wallet-error-page':
      return 'Wallet';
    default:
      return 'User Profile';
    }
  };

  const trackSearchInitiated = (method, keyword) => {
    const sourceInfo = checkSourceUrl();
    if (typeof window !== 'undefined') {
      window.analytics.track('Search Initiated', {
        input_method: method,
        search_input: keyword,
        source: sourceInfo,
      });
    }
  };

  // function for handling form submit
  const submitAction = (e) => {
    // prevents default, so page won't reload on form submit
    e.preventDefault();
    const { search } = e.target.elements; // search input
    if (search.value.trim().length > 0) {
      const searchValue = hashTagChecker(search.value);
      trackSearchInitiated('button', input);
      // add query string to URL
      history.push(`/search/index?s=${searchValue}`);
      setSuggestion([]);
    }
  };

  // function for handling form submit onClick - temporary solution for safari no focus support
  const submitActionOnClick = () => {
    if (input.trim().length > 0) {
      const searchValue = hashTagChecker(input);
      trackSearchInitiated('button', input);
      // add query string to URL
      history.push(`/search/index?s=${searchValue}`);
    }
  };

  // function for handling form submit onKeyPress - temporary solution for safari no focus support
  const submitActionOnKeyPress = (e) => {
    if (e.charCode === 13) {
      if (input.trim().length > 0) {
        const searchValue = hashTagChecker(input);
        trackSearchInitiated('button', input);
        // add query string to URL
        history.push(`/search/index?s=${searchValue}`);
      }
    }
  };

  useEffect(() => {
    const searchInput = document.getElementById('search-input-field');
    if (searchInput === document.activeElement) {
      setActiveSuggestion(false);
    } else {
      setActiveSuggestion(true);
    }
  }, [activeSuggestion, setActiveSuggestion]);

  // Unmount the component - cleanup function
  useEffect(() => function NavigatePath() {
    setInput('');
    setSuggestion([]);
  }, []);

  let isSafari;
  if (typeof navigator !== 'undefined') {
    isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
  return (
    <div className='search-navbar'>
      <form onSubmit={submitAction} autoComplete='off' ref={ref}>
        {isSafari
          ? (
            <>
              <input className='search-icon-safari' type='text' onClick={submitActionOnClick} maxLength='0' />
              <span className='search-icon-safari-span'><i className='fas fa-search' /></span>
            </>
          )
          : (
            <button className='search-icon' type='submit' data-testid='search-nav-submit'><i className='fas fa-search' /></button>
          )}
        <input type='text' name='search' className='input-search' value={input} placeholder='Search...' onClick={() => setIsMenuOpen((oldState) => !oldState)} onChange={(e) => setInput(e.target.value)} onKeyPress={isSafari ? submitActionOnKeyPress : undefined} data-testid='search-nav-input' id='search-input-field' />
        { isMenuOpen && (
          <SearchSuggestion
            input={input}
            suggestion={suggestion}
            setSuggestion={setSuggestion}
            sourceUrl={sourceUrl}
          />
        )}
      </form>
    </div>
  );
}
export default NavbarSearch;
